import { useMemo } from 'react';

export const useOverridePageSlug = <T extends { type: string; pageSlug: string }>(
  pages: ReadonlyArray<T>,
  overrides: {
    [type: string]: string; // type: slug
  } = {}
) => {
  const transformedPages = useMemo(
    () =>
      pages.map(page => {
        return page.type in overrides
          ? {
              ...page,
              pageSlug: overrides[page.type]
            }
          : page;
      }),
    [pages, overrides]
  );

  return transformedPages;
};
